"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59134],{

/***/ 40984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ loadingDatas; },
/* harmony export */   "A": function() { return /* binding */ loadingPacksDatas; }
/* harmony export */ });
var loadingDatas = [
    {
        name: 'skeleton-1'
    },
    {
        name: 'skeleton-2'
    },
    {
        name: 'skeleton-3'
    },
    {
        name: 'skeleton-4'
    },
    {
        name: 'skeleton-5'
    },
    {
        name: 'skeleton-6'
    },
    {
        name: 'skeleton-7'
    },
    {
        name: 'skeleton-8'
    },
    {
        name: 'skeleton-9'
    },
    {
        name: 'skeleton-10'
    },
    {
        name: 'skeleton-11'
    },
    {
        name: 'skeleton-12'
    }, 
];
var loadingPacksDatas = [
    {
        name: 'skeleton-1'
    },
    {
        name: 'skeleton-2'
    },
    {
        name: 'skeleton-3'
    },
    {
        name: 'skeleton-4'
    }, 
];


/***/ }),

/***/ 59134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Shop_ProductListContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Global/LoadingDatas.tsx
var LoadingDatas = __webpack_require__(40984);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./utils/takeBack.tsx + 2 modules
var takeBack = __webpack_require__(71323);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./components/Shop/ProductCard.tsx + 3 modules
var ProductCard = __webpack_require__(6144);
;// CONCATENATED MODULE: ./components/Shop/ProductGrid.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        col: {},
        md5: _defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        })
    };
});
var ProductGrid = function(param1) {
    var productsToShow = param1.productsToShow, availableProductsOnly = param1.availableProductsOnly, layout = param1.layout, isFiveColumns = param1.isFiveColumns, gridItemWidth = param1.gridItemWidth, settings = param1.settings, shopData = param1.shopData, productSettings = param1.productSettings, aspectRatio = param1.aspectRatio, cardWidth = param1.cardWidth, hidePrice = param1.hidePrice, basket = param1.basket, takeback = param1.takeback, isDisplayedPrice = param1.isDisplayedPrice, isSecondHandTaxon = param1.isSecondHandTaxon, mainData = param1.mainData, showSizedOnHover = param1.showSizedOnHover, sizeNotShown = param1.sizeNotShown, showImagesSlider = param1.showImagesSlider;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: productsToShow === null || productsToShow === void 0 ? void 0 : productsToShow.map(function(param, index) {
            var product = param.product, thumb = param.thumb, productAvailability = param.productAvailability;
            if (availableProductsOnly && product.enabled) {
                if (productAvailability.available || productAvailability.secondHandAvailable) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 6,
                        md: 4,
                        lg: layout ? 4 : isFiveColumns ? 2 : gridItemWidth,
                        className: "".concat(isFiveColumns ? classes.md5 : classes.col, " shop__grid__item"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                            addButton: true,
                            settings: settings,
                            shopData: shopData,
                            productSettings: productSettings,
                            index: index,
                            productCode: product.code,
                            slug: product.slug,
                            name: product.name,
                            thumb: thumb,
                            thumbRatio: aspectRatio,
                            thumbWidth: cardWidth,
                            product: product,
                            hidePrice: hidePrice,
                            basket: basket,
                            takeback: takeback,
                            isDisplayedPrice: isDisplayedPrice,
                            isSecondHandTaxon: isSecondHandTaxon,
                            showSizesOnHover: showSizedOnHover,
                            sizeNotShown: sizeNotShown,
                            showImagesSlider: showImagesSlider,
                            productAvailability: productAvailability
                        }, product.code)
                    }, product.code));
                }
                return null;
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 6,
                md: 4,
                lg: layout ? 4 : isFiveColumns ? 2 : gridItemWidth,
                className: "".concat(isFiveColumns ? classes.md5 : classes.col, " shop__grid__item"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                    addButton: true,
                    shopData: shopData,
                    settings: settings,
                    index: index,
                    productSettings: productSettings,
                    productCode: product.code,
                    slug: product.slug,
                    name: product.name,
                    thumb: thumb,
                    thumbRatio: aspectRatio,
                    thumbWidth: cardWidth,
                    product: product,
                    hidePrice: hidePrice,
                    basket: basket,
                    isDisplayedPrice: isDisplayedPrice,
                    takeback: takeback,
                    isSecondHandTaxon: isSecondHandTaxon,
                    mainData: mainData,
                    showSizesOnHover: showSizedOnHover,
                    sizeNotShown: sizeNotShown,
                    showImagesSlider: showImagesSlider,
                    productAvailability: productAvailability
                }, product.code)
            }, product.code));
        })
    }));
};
/* harmony default export */ var Shop_ProductGrid = (/*#__PURE__*/react.memo(ProductGrid));

;// CONCATENATED MODULE: ./components/Shop/Products.tsx












function Products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Products_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        rootFull: {
            marginTop: theme.spacing(3)
        },
        rootColumn: Products_defineProperty({}, theme.breakpoints.up('md'), {
            marginTop: theme.spacing(0)
        }),
        col: {},
        md5: Products_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        skeletonCard: {
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius
        },
        skeletonImg: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%'
        },
        skeletonContent: {
            padding: 10
        }
    });
});
var mapStateToProps = function(state) {
    return {
        productsError: state.products.error,
        stock: state.stock,
        takeBackState: state.takeBack,
        cart: state.cart
    };
};
var ProductsTab = function(param) {
    var products = param.products, stock1 = param.stock, shopData = param.shopData, mainData = param.mainData, settings = param.settings, availableProductsOnly = param.availableProductsOnly, loadMore = param.loadMore, hidePrice = param.hidePrice, basket = param.basket, takeback = param.takeback, _isDisplayedPrice = param.isDisplayedPrice, isDisplayedPrice = _isDisplayedPrice === void 0 ? true : _isDisplayedPrice, isLoadingProductsAndStocks = param.isLoadingProductsAndStocks, _isSearch = param.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, isSecondHandTaxon = param.isSecondHandTaxon, productSettings = param.productSettings, takeBackState1 = param.takeBackState, cart1 = param.cart, productsError = param.productsError;
    var ref8, ref1, ref2, ref3, ref4, ref5;
    var classes = Products_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var theme = (0,useTheme/* default */.Z)();
    var ref6 = (0,react.useState)(0), unavailableProductCount = ref6[0], setUnavailableProductCount = ref6[1];
    var layout = settings === null || settings === void 0 ? void 0 : settings.page_shop_layout;
    var columns = settings === null || settings === void 0 ? void 0 : settings.page_shop_desktop_columns;
    var thumbRatio = settings === null || settings === void 0 ? void 0 : settings.thumbnail_ratio;
    var cardWidth = settings === null || settings === void 0 ? void 0 : settings.medium_image_size;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(thumbRatio);
    var gridItemWidth = (0,utils/* columnLayout */.Zd)(columns);
    var isFiveColumns = gridItemWidth === '20%';
    var showImagesSlider = (0,react.useMemo)(function() {
        var ref;
        return mainData === null || mainData === void 0 ? void 0 : (ref = mainData.data) === null || ref === void 0 ? void 0 : ref.show_product_item_slider;
    }, [
        mainData === null || mainData === void 0 ? void 0 : (ref8 = mainData.data) === null || ref8 === void 0 ? void 0 : ref8.show_product_item_slider
    ]);
    var isSM = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var sizeNotShown = (mainData === null || mainData === void 0 ? void 0 : (ref1 = mainData.data) === null || ref1 === void 0 ? void 0 : ref1.sizes_not_shown_on_mobile) && isSM;
    var showSizedOnHover = mainData === null || mainData === void 0 ? void 0 : (ref2 = mainData.data) === null || ref2 === void 0 ? void 0 : ref2.sizes_on_hover;
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var states1 = (0,react.useMemo)(function() {
        return productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    }, [
        takeback === null || takeback === void 0 ? void 0 : takeback.data
    ]);
    var ref7 = (0,react.useState)([]), productsToShow = ref7[0], setProductsToShow = ref7[1];
    (0,react.useEffect)(function() {
        if (products && stock1 && stock1.stock && !takeBackState1.loading && !isLoadingProductsAndStocks) {
            var newProductsToShow = products.map(function(product) {
                var ref;
                var productAvailability = (0,utils/* checkProductAvailability */.HF)(stock1, product);
                if (product.enabled && availableProductsOnly && !productAvailability.available && !productAvailability.secondHandAvailable) {
                    return null;
                }
                var thumb = !showImagesSlider ? product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.slice(0, 1) : processProductImages(product, productAvailability, stock1, takeBackState1, states1, cart1);
                return {
                    product: product,
                    thumb: thumb,
                    productAvailability: productAvailability
                };
            }).filter(Boolean);
            setProductsToShow(newProductsToShow);
            setUnavailableProductCount(products.length - newProductsToShow.length);
        }
    }, [
        products,
        stock1.stock,
        isLoadingProductsAndStocks,
        takeBackState1.loading,
        showImagesSlider,
        availableProductsOnly,
        states1, 
    ]);
    var processProductImages = (0,react.useMemo)(function() {
        return function(product, productAvailability, stock, takeBackState, states, cart) {
            var ref10, ref9;
            if (!isSecondHandTaxon || !((ref10 = productAvailability.secondHandImage) === null || ref10 === void 0 ? void 0 : ref10.length)) {
                return (product === null || product === void 0 ? void 0 : product.images) || [];
            }
            var currentProductSkus = Object.values(product.variants).map(function(v) {
                return v.sku;
            });
            var secondHandStock = new Set(currentProductSkus.map(function(sku) {
                var ref;
                return (ref = stock.stockMap) === null || ref === void 0 ? void 0 : ref.get(sku);
            }).filter(Boolean));
            var takeBackStock = new Set(currentProductSkus.map(function(sku) {
                var ref;
                return (ref = takeBackState.takeBackStockMap) === null || ref === void 0 ? void 0 : ref.get(sku);
            }).filter(Boolean));
            if (!secondHandStock.size || !takeBackStock.size) {
                return productAvailability.secondHandImage.concat(product === null || product === void 0 ? void 0 : product.images);
            }
            var chosen = (0,takeBack/* preSelectedSkuAndCondition */.dE)(Array.from(secondHandStock), product, Array.from(takeBackStock), states, cart, Boolean);
            var images = (ref9 = chosen.item) === null || ref9 === void 0 ? void 0 : ref9.images;
            return (images === null || images === void 0 ? void 0 : images.length) ? Array.from(new Set(images.map(function(img) {
                return img.path;
            })).values()).map(function(path) {
                return {
                    path: path
                };
            }) : productAvailability.secondHandImage.concat(product === null || product === void 0 ? void 0 : product.images);
        };
    }, [
        isSecondHandTaxon
    ]);
    console.log('productsToShow.length', productsToShow.length);
    console.log('unavailableProductCount', unavailableProductCount);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            component: "section",
            spacing: 3,
            className: layout ? "shop__grid ".concat(classes.rootColumn) : "shop__grid ".concat(classes.rootFull),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    loadMore && productsToShow && stock1 && stock1.stock && !isLoadingProductsAndStocks && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductGrid, {
                        productsToShow: productsToShow,
                        availableProductsOnly: availableProductsOnly,
                        layout: layout,
                        isFiveColumns: isFiveColumns,
                        gridItemWidth: gridItemWidth,
                        settings: settings,
                        shopData: shopData,
                        productSettings: productSettings,
                        aspectRatio: aspectRatio,
                        cardWidth: cardWidth,
                        hidePrice: hidePrice,
                        basket: basket,
                        takeback: takeback,
                        isDisplayedPrice: isDisplayedPrice,
                        isSecondHandTaxon: isSecondHandTaxon,
                        mainData: mainData,
                        showSizedOnHover: showSizedOnHover,
                        sizeNotShown: sizeNotShown,
                        showImagesSlider: showImagesSlider
                    }),
                    isLoadingProductsAndStocks && (LoadingDatas/* loadingDatas */.k === null || LoadingDatas/* loadingDatas */.k === void 0 ? void 0 : LoadingDatas/* loadingDatas.map */.k.map(function(loadingData) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 6,
                            md: 4,
                            lg: layout ? 4 : isFiveColumns ? 2 : gridItemWidth,
                            className: "".concat(isFiveColumns ? classes.md5 : classes.col, " shop__grid__item"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.skeletonCard,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-ratio": aspectRatio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            variant: "rect",
                                            className: classes.skeletonImg
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.skeletonContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "text"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "text",
                                                width: "60%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "text",
                                                width: "30%"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "item-".concat(loadingData.name));
                    })),
                    !isLoadingProductsAndStocks && (productsToShow === null || productsToShow === void 0 ? void 0 : productsToShow.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'h4',
                            align: "center",
                            children: productsError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: shopData === null || shopData === void 0 ? void 0 : (ref3 = shopData.data) === null || ref3 === void 0 ? void 0 : ref3.error_text,
                                defaultText: t('texts:shop:error_loading_products'),
                                asText: true
                            }) : isSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: mainData === null || mainData === void 0 ? void 0 : (ref4 = mainData.data) === null || ref4 === void 0 ? void 0 : ref4.search_not_found_text,
                                defaultText: t('texts:shop:search_not_found'),
                                asText: true
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: shopData === null || shopData === void 0 ? void 0 : (ref5 = shopData.data) === null || ref5 === void 0 ? void 0 : ref5.no_stock_available,
                                defaultText: t('texts:shop:no_stock_available'),
                                asText: true
                            })
                        })
                    }),
                    productsToShow && stock1 && !loadMore && stock1.stock && !isLoadingProductsAndStocks && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductGrid, {
                        productsToShow: productsToShow,
                        availableProductsOnly: availableProductsOnly,
                        layout: layout,
                        isFiveColumns: isFiveColumns,
                        gridItemWidth: gridItemWidth,
                        settings: settings,
                        shopData: shopData,
                        productSettings: productSettings,
                        aspectRatio: aspectRatio,
                        cardWidth: cardWidth,
                        hidePrice: hidePrice,
                        basket: basket,
                        takeback: takeback,
                        isDisplayedPrice: isDisplayedPrice,
                        isSecondHandTaxon: isSecondHandTaxon,
                        mainData: mainData,
                        showSizedOnHover: showSizedOnHover,
                        sizeNotShown: sizeNotShown,
                        showImagesSlider: showImagesSlider
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Products = ((0,es/* connect */.$j)(mapStateToProps)(ProductsTab));

;// CONCATENATED MODULE: ./components/Shop/ProductListContainer.tsx







var ProductListContainer_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        row: {
            display: 'inline-flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 50
        },
        rowCenter: {
            display: 'inline-flex',
            justifyContent: 'center',
            width: '100%',
            marginTop: 50
        },
        alignCenter: {
            textAlign: 'center'
        },
        marginTop: {
            marginTop: theme.spacing(1)
        },
        loadMoreBtnLoader: {
            width: '100%',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center'
        }
    };
});
var ProductListContainer = function(param) {
    var products = param.products, loadMore = param.loadMore, availableProductsOnly = param.availableProductsOnly, shopData = param.shopData, settings = param.settings, hidePrice = param.hidePrice, basket = param.basket, takeback = param.takeback, isDisplayedPrice = param.isDisplayedPrice, isLoadingProductsAndStocks = param.isLoadingProductsAndStocks, isSearch = param.isSearch, mainData = param.mainData, productSettings = param.productSettings, isSecondHandTaxon = param.isSecondHandTaxon, currentPage = param.currentPage, handlePrev = param.handlePrev, handleNext = param.handleNext, handleLoadMore = param.handleLoadMore, loadingMoreProducts = param.loadingMoreProducts;
    var ref, ref1, ref2, ref3, ref4;
    var classes = ProductListContainer_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var currentNumberShown = (0,react.useMemo)(function() {
        return products.page * products.limit > products.total ? products.total : products.page * products.limit;
    }, [
        products.page,
        products.limit,
        products.total
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
                loadMore: loadMore,
                availableProductsOnly: availableProductsOnly,
                shopData: shopData,
                settings: settings,
                hidePrice: hidePrice,
                basket: basket,
                takeback: takeback,
                isDisplayedPrice: isDisplayedPrice,
                isLoadingProductsAndStocks: isLoadingProductsAndStocks,
                isSearch: isSearch,
                mainData: mainData,
                productSettings: productSettings,
                isSecondHandTaxon: isSecondHandTaxon,
                products: products.items
            }),
            (products === null || products === void 0 ? void 0 : products.pages) > 1 && (!loadMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.row,
                children: [
                    currentPage !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: 'contained',
                        color: 'primary',
                        size: 'small',
                        onClick: handlePrev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: shopData === null || shopData === void 0 ? void 0 : (ref = shopData.data) === null || ref === void 0 ? void 0 : ref.prev,
                            defaultText: t('texts:shop:prev')
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    currentPage < (products === null || products === void 0 ? void 0 : products.pages) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: 'contained',
                        color: 'primary',
                        size: 'small',
                        onClick: handleNext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: shopData === null || shopData === void 0 ? void 0 : (ref1 = shopData.data) === null || ref1 === void 0 ? void 0 : ref1.next,
                            defaultText: t('texts:shop:next')
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.rowCenter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.alignCenter,
                    children: [
                        products.total !== currentNumberShown && !loadingMoreProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: 'contained',
                            color: 'primary',
                            size: 'small',
                            onClick: handleLoadMore,
                            disabled: loadingMoreProducts,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: shopData === null || shopData === void 0 ? void 0 : (ref2 = shopData.data) === null || ref2 === void 0 ? void 0 : ref2.load_more_button,
                                defaultText: t('texts:shop:load_more_button')
                            })
                        }),
                        loadingMoreProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.loadMoreBtnLoader,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 20
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.marginTop,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: shopData === null || shopData === void 0 ? void 0 : (ref3 = shopData.data) === null || ref3 === void 0 ? void 0 : ref3.you_have_seen,
                                    defaultText: t('texts:shop:you_have_seen')
                                }),
                                ' ',
                                currentNumberShown,
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: shopData === null || shopData === void 0 ? void 0 : (ref4 = shopData.data) === null || ref4 === void 0 ? void 0 : ref4.articles_on,
                                    defaultText: t('texts:shop:articles_on')
                                }),
                                ' ',
                                products.total
                            ]
                        })
                    ]
                })
            }))
        ]
    }));
};
/* harmony default export */ var Shop_ProductListContainer = (/*#__PURE__*/react.memo(ProductListContainer));


/***/ })

}]);